
<el-container class="screen-parameters screen-parameters-fullHeight services" v-loading="loading || loadingDelete">
  <div class="clients-panel cash-list">
    <div class="clients-panel-container">
      <el-row class="black-inputs">
        <div class="cash-header">
          <div class="nav-toggle" @click="showHideScreenResaList">
            <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
          </div>
        </div>
        <br>
        <el-row class="dateChooser" :gutter="5">
          <el-col class="alignCenter" :md="{ span: 4 }" :sm="{ span: 8 }" :xs="24">
            <el-date-picker class="datePicker" v-model="datesResaStart" type="date" :picker-options="pickerOptions"
              placeholder="Date de début" @change="updateResaDateStart()" format="dd/MM/yyyy">
            </el-date-picker>
          </el-col>
          <el-col class="alignCenter" :md="{ span: 4, offset: 1 }" :sm="{ span: 8 }" :xs="24">
            <el-date-picker class="datePicker" v-model="datesResaEnd" type="date" :picker-options="pickerOptions"
              placeholder="Date de fin" @change="updateResaDateEnd()" format="dd/MM/yyyy">
            </el-date-picker>
          </el-col>
          <el-col :md="{ span: 4, offset: 1 }" :sm="{ span: 8 }" :xs="24">
            <el-select v-model="serviceResa" placeholder="Service">
              <el-option v-for="t in getServices" :key="t" :label="t" :value="t">
              </el-option>
            </el-select>
          </el-col>
          <el-col :md="{ span: 3, offset: 0 }" :xs="24" :sm="{ span: 8 }">
            <el-button type="primary" @click="showResaEntry()">Afficher</el-button>
          </el-col>
          <el-col :md="{ span: 3, offset: 0 }" :xs="24" :sm="{ span: 8 }">
            <el-button :disabled="resasList.length === 0" class="dark" @click="printResas">Imprimer</el-button>
          </el-col>
          <el-col :md="{ span: 3, offset: 1 }" :xs="24" :sm="{ span: 8 }">
            <el-button v-if="datesResaStart !== '' && datesResaEnd !== ''" class="dark"
              @click="reinit()">Réinitialiser</el-button>
            <div v-else style="height:1px; width:100%"> </div>
          </el-col>
        </el-row>
      </el-row>
      <el-row class="black-inputs">
        <el-col id="listResasToPrint" :md="24" class="screen-clients resa-list">
          <div v-for="(resa, index) in resasList" :key="index" class="print-ok">
            <div v-if="index === 0 || resasList[index - 1].dateResa.labelMonth !== resa.dateResa.labelMonth">
              {{ resa.dateResa.labelMonth }} {{ resa.dateResa.year }}
              <div class="seperator"></div>
              <div class="hide" style="width:100%; border-bottom:1px solid black; margin:10px 0"></div>
            </div>
            - {{ resa.dateResa.labelDay }} {{ resa.dateResa.day }} - {{ resa.hour }} <span v-if="resa.room !== ''">-
              {{ getRoomName(resa.room) }} </span>
            - {{ getClientByid(resa.cid).civ }} {{ getClientByid(resa.cid).name }} {{ getClientByid(resa.cid).prenom
            }}
            <a class="phone-link" v-if="getClientByid(resa.cid).tel && getClientByid(resa.cid).tel !== ''"
              :href="'tel:' + formatPhone(getClientByid(resa.cid).tel, getClientByid(resa.cid).telPreFix)">
              - {{ formatPhone(getClientByid(resa.cid).tel, getClientByid(resa.cid).telPreFix) }} -
            </a>
            ( {{ resa.nbCouvert }} ) <span v-if="getAllTablesString(resa) !== ''">- {{ getAllTablesString(resa)
            }}</span>
            <span v-if="resa.allergen"><span class="icon-allergen"></span><span class="hide">- allergène /
                intolérance</span><span class="allergen-text">({{ resa.allergenMessage }})</span></span>
            <span v-if="resa.commentResa && resa.commentResa !== ''">
              <span style="margin-left:10px"> -> {{ resa.commentResa }}</span>
            </span>
            - <i class="el-icon-view icon-btn" @click="gotoResa(resa)"></i>
            <div class="seperator-light"></div>
            <div class="hide" style="width:100%; border-bottom:1px dashed black; margin:10px 0"></div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</el-container>
